import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';


const getFrameworkAgreementFilesCount = (frameworkAgreemenId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreemenId}/files/count`
  );
};

export const useFrameworkAgreementFilesCount = (frameworkAgreementId, options = {}) => {
  return useQuery(
    `framework-agreement-${frameworkAgreementId}-files-count`,
    () => getFrameworkAgreementFilesCount(frameworkAgreementId),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
};